<template>
	<div>
		<div class="search">
			<van-popover v-model="showPopover" trigger="click" :actions="actions"  @select="onSelect">
				<template #reference>
					<div class="select">{{actions[type].text}} <van-icon name="arrow-down" /></div>
				</template>
			</van-popover>
			<van-search v-model="k" placeholder="请输入搜索关键词" @search="search">

			</van-search>
		</div>

		<div class="box" v-if="haofang.length > 0">
			<div class="box-c">
				<div class="houselist">
					<div class="box-t-1">{{ community }}小区房源</div>
					<ul>
						<li v-for="(item, index) in haofang" :key="index" @click="goto(item.id)">
							<div class="img">
								<img :src="item.thumbnail" />
							</div>
							<div class="info">
								<h1>
									{{ item.title }}
									{{ item.price ? item.price + item.unit : "面议" }}
								</h1>
								<p class="tag">
									<van-tag color="#ecf3fe" text-color="#6e86b1" v-for="(v, i) in item.peitao" :key="i" v-if="i < 3">{{ v }}</van-tag>
								</p>
								<div class="pflex">
									<p class="txt2">
										{{ item.shi }}{{ item.ting }} | {{ item.community }}
									</p>
									<p class="txt1">
										{{ item.price ? item.price : "面议" }}
										<small v-if="item.price">{{ item.unit }}</small>
									</p>
								</div>
								<div class="">
									<p class="txt2">{{ item.refreshtime }}</p>
								</div>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<div class="container" id="container"></div>
	</div>
</template>

<script>
	var root = process.env.VUE_APP_API_URL;

	import Footbar from "./commpents/footbar";

	import {
		Button,
		Dialog,
		Swipe,
		SwipeItem,
		Icon,
		Search,
		Tab,
		Tabs,
		Popover,
		Tag
	} from "vant";

	export default {
		components: {
			[Button.name]: Button,
			[Dialog.Component.name]: Dialog.Component,
			[Swipe.name]: Swipe,
			[SwipeItem.name]: SwipeItem,
			[Search.name]: Search,
			[Icon.name]: Icon,
			[Tab.name]: Tab,
			[Tabs.name]: Tabs,
			[Popover.name]: Popover,
			[Tag.name]: Tag
		},

		data() {
			return {
				getInitUrl: root + "map/index",
				map: "",
				latlng: [],
				donutList: [],
				haofang: [],
				community: "",
				k: "",
				type: 1,
				CustomOverlay: "",
				active: 0,
				showPopover: false,
				actions: [{
					text: '租房'
				},{
					text: '二手房'
				},  {
					text: '商铺'
				}],
			};
		},

		mounted() {
			this.init();
			this.type = this.$route.params.type;
			//定义地图中心点坐标
			var center = new TMap.LatLng(29.991634, 108.116667);
			//定义map变量，调用 TMap.Map() 构造函数创建地图
			this.map = new TMap.Map(document.getElementById("container"), {
				center: center, //设置地图中心点坐标
				zoom: 16,
				viewMode: "2D",
				showControl: false,
			});

			//自定义DOM覆盖物 - 继承DOMOverlay

			this.CustomOverlay = function(options) {
				TMap.DOMOverlay.call(this, options);
			};
			this.CustomOverlay.prototype = new TMap.DOMOverlay();

			// 初始化
			this.CustomOverlay.prototype.onInit = function(options) {
				this.position = options.position;
				this.content = options.content;
				this.community = options.community;
			};
			// 销毁时需解绑事件监听
			this.CustomOverlay.prototype.onDestroy = function() {
				if (this.onClick) {
					this.dom.removeEventListener(this.onClick);
				}
			};
			// 创建DOM元素，返回一个DOMElement
			this.CustomOverlay.prototype.createDOM = function() {
				var mydom = (this.mydom = document.createElement("div"));
				//设置DOM样式
				mydom.style.cssText =
					"text-align: center;background-color: rgba(248,98,0,0.8);box-sizing: border-box;min-width:60px;color: #fff;padding:20px 20px;padding: 5px; font-size: 12px;position: absolute;top: 0px;left: 0px;border-radius:4px;display: flex;justify-content: center;align-items: center;";
				mydom.innerHTML = this.content;
				// click事件监听
				this.onClick = () => {
					// DOMOverlay继承自EventEmitter，可以使用emit触发事件
					this.emit("touchstart");
				};
				mydom.addEventListener("touchstart", this.onClick);
				return mydom;
			};

			// 更新DOM元素，在地图移动/缩放后执行
			this.CustomOverlay.prototype.updateDOM = function() {
				if (!this.map) {
					return;
				}

				// 经纬度坐标转容器像素坐标
				let pixel = this.map.projectToContainer(this.position);

				// 使饼图中心点对齐经纬度坐标点
				let left = pixel.getX() - this.dom.clientWidth / 2 + "px";
				let top = pixel.getY() - this.dom.clientHeight / 2 + "px";
				this.dom.style.transform = `translate(${left}, ${top})`;
			};

			var that = this;
			setTimeout(function() {
				for (var i in that.latlng) {
					if (
						that.latlng[i].lat.indexOf(".") > -1 &&
						that.latlng[i].lng.indexOf(".") > -1
					) {
						that.donutList.push(
							new that.CustomOverlay({
								map: that.map,
								position: new TMap.LatLng(that.latlng[i].lat, that.latlng[i].lng),
								content: that.latlng[i].total + "套" + "<br>" + that.latlng[i].community,
								community: that.latlng[i].community,
							})
						);
					}
				}
				that.donutList.forEach((donut, index) => {
					donut.on("touchstart", () => {
						//that.$toast('功能待添加');
						console.log(1)
						that.community = donut.community;
						that.haofang = [];
						that.init();
					});
				});
			}, 2000);
		},

		methods: {
			init() {
				var self = this;
				$.ajax({
					url: self.getInitUrl,
					timeout: 120000,
					dataType: "json",
					type: "get",
					data: {
						type: self.type,
						community: self.community,
					},
					headers: self.getRequestHeader(),
					success: function(res) {
						console.log(res);
						self.latlng = res.lists;
						self.haofang = res.haofang;
					},
					error: function() {
						self.$toast("system error");
					},
				});
			},
			search(value) {
				this.community = value;
				this.donutList.forEach((donut, index) => {
					donut.setMap(null);
				});
				var that = this;
				setTimeout(function() {
					for (var i in that.latlng) {
						if (
							that.latlng[i].lat.indexOf(".") > -1 &&
							that.latlng[i].lng.indexOf(".") > -1
						) {
							that.map.setCenter(
								new TMap.LatLng(that.latlng[i].lat, that.latlng[i].lng)
							);
							that.donutList.push(
								new that.CustomOverlay({
									map: that.map,
									position: new TMap.LatLng(
										that.latlng[i].lat,
										that.latlng[i].lng
									),
									content: that.latlng[i].total +
										"套" +
										"<br>" +
										that.latlng[i].community,
									community: that.latlng[i].community,
								})
							);
						}
					}
					that.donutList.forEach((donut, index) => {
						donut.on("touchstart", () => {
							//that.$toast('功能待添加');
							console.log(1)
							that.community = donut.community;
							that.haofang = [];
							that.init();
						});
					});
				}, 2000);
				this.init();
			},
			goto(id) {
				if (this.type == 1) {
					this.$router.push("/ershoufang/view/" + id);
				} else if(this.type == 0) {
					this.$router.push("/zufang/view/" + id);
				}else{
					this.$router.push("/shop/view/" + id);
				}
			},
			onSelect(action,index){
				console.log(action,index)
				this.type = index
				this.search('')
			}
		},
	};
</script>

<style scoped>
	.container {
		height: 100vh;
		width: 100vw;
	}

	.search {
		position: fixed;
		top: 0;
		width: 100%;
		z-index: 10000;
		display: flex;
		background-color: #fff;
		align-items: center;
	}

	.search .select {
		width: 90px;
		text-align: center;
		background-color: #F7F8FA;
		height: 32px;
		line-height: 32px;
		margin-left: 15px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.search .van-icon{
		margin-left: 6px;
	}
	.search .van-search{
		flex: 1;
	}
	.box {
		position: fixed;
		width: 100%;
		height: 45vh;
		overflow: auto;
		background: #fff;
		bottom: 0;
		z-index: 10000;
		border-top-right-radius: 20px;
		border-top-left-radius: 20px;
	}

	.box .box-t-1 {
		font-size: 18px;
		margin-bottom: 0;
		padding: 0;
	}

	.box .box-c {
		padding: 0;
	}
</style>
